import React from "react";

import ReactDOM from "react-dom";

import type { JSX, MouseEvent } from "react";

interface ActionsDropdownProps {
  itemPosition: DOMRect;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  actions: (index: number, data: unknown) => JSX.Element;
  index: number;
  data: unknown;
}

function ActionsDropdown({
  itemPosition,
  onClick,
  actions,
  index,
  data,
}: ActionsDropdownProps): JSX.Element | null {
  const { left, top, height, width } = itemPosition || {};

  const dropdownStyle = {
    left: `${left}px`,
    top: `${top + height}px`,
    width: `${width}px`,
  };

  const dropdownContent = (
    <div
      className="actions-dropdown-container"
      onClick={(event: MouseEvent<HTMLElement>): void => onClick(event)}
    >
      <div className="actions-dropdown" style={dropdownStyle}>
        {actions(index, data)}
      </div>
    </div>
  );

  const portalElement = document.body;

  return portalElement
    ? ReactDOM.createPortal(dropdownContent, portalElement)
    : null;
}

export default ActionsDropdown;
